import { HttpInterceptorFn } from '@angular/common/http';
import { switchMap, take } from 'rxjs';
import { inject } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';

export const tokenInterceptor: HttpInterceptorFn = (request, next) => {
  if (/^(?:\/|.\/)?assets/.test(request.url)) {
    return next(request);
  }

  const auth = inject(AuthService);

  return auth.getAccessTokenSilently().pipe(
    take(1),
    switchMap(token => {
      // Auth0 types the token as optional: it resolves or errors in practice,
      // so this mostly narrows the type. With no token there is no credential
      // to present, and sending the header as the string "undefined" would be
      // worse than sending none at all.
      if (!token) {
        return next(request);
      }

      return next(
        request.url.includes('signer')
          ? request.clone({
              setHeaders: { Authorization: token },
              withCredentials: true,
            })
          : request.clone({
              setHeaders: { Authorization: token },
            }),
      );
    }),
  );
};
